import React from 'react';
import { Box, Heading, Grid, Button, Icon } from '@chakra-ui/react';
import { FaPlus, FaProjectDiagram, FaUsers } from 'react-icons/fa';
import { PermissionGuard } from '../PermissionGuard';
import { Permission } from '../../utils/permissions';
import LimitRestrictedButton from '../LimitRestrictedButton';

interface QuickActionsProps {
  onCreateTask: () => void;
  onCreateProject: () => void;
  onCreateClient: () => void;
}

const QuickActions: React.FC<QuickActionsProps> = ({
  onCreateTask,
  onCreateProject,
  onCreateClient,
}) => {
  return (
    <Box mb={8}>
      <PermissionGuard permission={Permission.CREATE_TASKS}>
        <Heading size="md" mb={6} color="gray.800">
          Quick Actions
        </Heading>
      </PermissionGuard>
      <Grid templateColumns="repeat(auto-fit, minmax(250px, 1fr))" gap={4}>
        <PermissionGuard permission={Permission.CREATE_TASKS}>
          <Button
            leftIcon={<Icon as={FaPlus} />}
            colorScheme="orange"
            size="lg"
            borderRadius="xl"
            h="80px"
            _hover={{ transform: 'translateY(-2px)' }}
            transition="all 0.2s"
            onClick={onCreateTask}
          >
            Create New Task
          </Button>
        </PermissionGuard>
        <PermissionGuard permission={Permission.CREATE_PROJECTS}>
          <LimitRestrictedButton
            resource="projects"
            leftIcon={<Icon as={FaProjectDiagram} />}
            colorScheme="green"
            w={"100%"}
            size="lg"
            borderRadius="xl"
            h="80px"
            _hover={{ transform: 'translateY(-2px)' }}
            transition="all 0.2s"
            onClick={onCreateProject}
          >
            New Project
          </LimitRestrictedButton>
        </PermissionGuard>
        <PermissionGuard permission={Permission.CREATE_CLIENTS}>
          <LimitRestrictedButton
            resource="clients"
            leftIcon={<Icon as={FaUsers} />}
            colorScheme="cyan"
            color="white"
            bgGradient="linear(to-r, cyan.400, blue.500)"
            w={"100%"}
            size="lg"
            borderRadius="xl"
            h="80px"
            _hover={{ transform: 'translateY(-2px)' }}
            transition="all 0.2s"
            onClick={onCreateClient}
          >
            Add Client
          </LimitRestrictedButton>
        </PermissionGuard>
      </Grid>
    </Box>
  );
};

export default QuickActions;
